import React, { useState } from "react";
import { Card, Divider, Flex, Typography } from "antd";

/* ICONS */

import { ReactComponent as SpoonIconBlack } from "../assets/images/spoonIconBlack.svg";
import { ReactComponent as ClockIcon } from "../assets/images/clockIcon.svg";
import { ReactComponent as HotelBellIcon } from "../assets/images/hotelBell.svg";

const { Title } = Typography;

/**
 * Props shape:
 * activity = {
 *   image: string,
 *   name: string,
 *   description: string,
 *   duration: { value: string, available: boolean },
 *   lunch: { value: string, available: boolean },
 *   dinner: { value: string, available: boolean }
 * }
 */

const ActivitiesBlock = ({ activity, title = "Activities" }) => {
  const [expanded, setExpanded] = useState(false);
  if (!activity) return null;

  const { image, name, location, description, duration, lunch, dinner } =
    activity;

  const [prefix, suffix] = name?.split("ACTIVITY") || [];

  return (
    <>
      <Card className="rounded-xl shadow-sm overflow-hidden border border-gray-200">
        <div className="gap-4 flex flex-col">
          {/* IMAGE */}
          <div className="relative rounded-lg overflow-hidden">
            <div className="absolute inset-0 bg-[#2A2D35] opacity-30 rounded-xl" />

            {image && (
              <img
                src={image}
                alt={name}
                className="w-full h-full object-cover object-wrapper"
              />
            )}

            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 text-white">
              <div className="text-sm font-medium">{prefix}</div>
              {suffix && <div className="text-xs">ACTIVITY{suffix}</div>}
              <small>{location}</small>
            </div>
          </div>

          {/* DETAILS */}
          <div className="flex flex-col justify-between">
            <p
              className={`text-sm font-medium ${expanded ? "" : "line-clamp-2"
                }`}
            >
              {description}
            </p>

            <button
              onClick={() => setExpanded(!expanded)}
              className="mt-1 text-xs text-primary font-medium hover:underline text-left"
            >
              {expanded ? "Show less" : "Show more"}
            </button>
            {(duration || lunch?.available === true || dinner?.available === true) && (
              <div className="mt-3 space-y-2 text-xs">
                {/* DURATION */}
                {duration && (
                  <InfoRow
                    icon={<ClockIcon />}
                    value={duration.value}
                    available={duration.available}
                  />
                )}

                {/* LUNCH */}
                {lunch?.available === true && (
                  <InfoRow
                    icon={<ClockIcon />}
                    value={lunch.value}
                    available={lunch.available}
                    availableText="Included ✓"
                    unavailableText="Not Included ✗"
                  />
                )}

                {/* DINNER */}
                {dinner?.available === true && (
                  <InfoRow
                    icon={<HotelBellIcon className="blackIcon" />}
                    value={dinner.value}
                    available={dinner.available}
                    availableText="Included ✓"
                    unavailableText="Not Included ✗"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    </>
  );
};

/* ---------- SMALL HELPER ---------- */
const InfoRow = ({
  icon,
  value,
  available,
  availableText,
  unavailableText,
}) => (
  <Flex gap={8} align="center">
    {icon}
    <span>
      {value}{" "}
      <span className={available ? "text-[#0EFF3A]" : "text-[#FF0000]"}>
        {available ? availableText : unavailableText}
      </span>
    </span>
  </Flex>
);

export default ActivitiesBlock;
